import React from 'react'
import { Box, Icon, Tooltip, Text } from 'elements'
import { useModals } from 'hooks'
import ReportStatusDetailsModal from './ReportStatusDetailsModal'

const statusIcons = {
  DRAFT: 'refresh',
  PENDING: 'refresh',
  PROCESSING: 'refresh',
  SUCCESS: 'check-circle',
  ERROR: 'exclamation-circle',
}

const statusColors = {
  DRAFT: 'neutral.0',
  PENDING: 'neutral.0',
  PROCESSING: 'neutral.0',
  SUCCESS: 'primary.0',
  ERROR: 'warning.0',
}

const processingStatuses = ['DRAFT', 'PENDING', 'PROCESSING']

export default function ReportStatus({ report }) {
  const { openModal } = useModals()
  const { status } = report

  const processing = processingStatuses.includes(status)

  const handleViewDetails = () =>
    openModal(ReportStatusDetailsModal, { reportRowId: report.rowId }, 'full')

  const iconStyle = processing ? { transform: 'scaleY(-1)' } : null

  if (status === 'ERROR') {
    return (
      <>
        <Icon
          data-tip
          name={statusIcons[status]}
          size="large"
          color={statusColors[status]}
          onClick={handleViewDetails}
        />
        <Tooltip clickable>
          <Box textAlign="center">
            <Text color="neutral.0">View details</Text>
          </Box>
        </Tooltip>
      </>
    )
  } else {
    return (
      <Icon
        name={statusIcons[status]}
        size="large"
        color={statusColors[status]}
        spin={processing}
        style={iconStyle}
      />
    )
  }
}
